import { FunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";

import { CompaniesView } from "./pages/CompaniesView";
import { ContactsIndexRoute } from "./pages/ContactsIndexRoute";

export const Contacts: FunctionComponent = () => {
	return (
		<Routes>
			<Route index element={<ContactsIndexRoute />} />
			<Route element={<CompaniesView />} path="companies" />
		</Routes>
	);
};
